import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'aayuwell-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Aayu Well',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: '',
  email: 'support@aayuwell.com',
  poweredByLogo: true,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/aayuwell/index.js